module.exports = __webpack_public_path__ + "static/media/scoliosis_severe_right.60caf96f.png";